import { Flex, Icon, Spacer, Text } from '@backyard-ui/core';

import { BlockIcon } from './BlockIcon';

export default function Unavailable() {
  return (
    <Flex
      className="w-full border-t-4 border-neutral-700 pt-2"
      direction="column"
      data-testid="unavailable"
    >
      <Text size="3xl" color="neutral-700" asChild>
        <span>Item indisponível</span>
      </Text>
      <Spacer size="1" axis="vertical" />
      <Flex>
        <Icon size="sm" UNSAFE_className="text-neutral-700">
          <BlockIcon />
        </Icon>
        <Spacer size="1" />
        <Text size="md" color="neutral-700" weight="bold" asChild>
          <span>
            No momento, este item não está disponível em nossos estoques
          </span>
        </Text>
      </Flex>
    </Flex>
  );
}
